import { Sticker, StickerWithInspectionData } from '.'

export const isStickerHasInspectionData = (
  sticker: Sticker,
): sticker is StickerWithInspectionData => {
  if (!sticker.stickerInspectionData) {
    return false
  }

  if (sticker.stickerInspectionData) {
    if (!sticker.stickerInspectionData.unapprovedCauses) {
      return false
    }
    if (
      sticker.stickerInspectionData.unapprovedCauses &&
      sticker.stickerInspectionData.unapprovedCauses.length === 0
    ) {
      return false
    }
  }
  return true
}
